import { render, staticRenderFns } from "./thirdparty_list.vue?vue&type=template&id=72982826&scoped=true"
import script from "./thirdparty_list.vue?vue&type=script&lang=js"
export * from "./thirdparty_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72982826",
  null
  
)

export default component.exports